"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILErrorBoundary = exports.FallbackWithRedirect = void 0;
var react_1 = __importDefault(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var get_component_1 = require("../../shared/helpers/get-component");
function FallbackWithRedirect(_a) {
    var error = _a.error, resetErrorBoundary = _a.resetErrorBoundary, _b = _a.timeout, timeout = _b === void 0 ? 6000 : _b, _c = _a.redirectTo, redirectTo = _c === void 0 ? '/' : _c, customMessage = _a.customMessage;
    var navigate = (0, react_router_dom_1.useNavigate)();
    react_1.default.useEffect(function () {
        var timer = setTimeout(function () {
            navigate(redirectTo);
            resetErrorBoundary();
        }, timeout);
        return function () {
            clearTimeout(timer);
        };
    }, [resetErrorBoundary, navigate, timeout, redirectTo]);
    return (react_1.default.createElement(material_1.Box, { sx: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            backgroundColor: 'background.paper',
        } },
        customMessage,
        (error === null || error === void 0 ? void 0 : error.message) && react_1.default.createElement(material_1.Box, { maxWidth: "md" },
            "Error: ",
            error.message)));
}
exports.FallbackWithRedirect = FallbackWithRedirect;
var ILErrorBoundary = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { FallbackComponent: (0, get_component_1.getComponent)(FallbackWithRedirect, props) }, children));
};
exports.ILErrorBoundary = ILErrorBoundary;
